/**
 * Quick add to cart.
 *
 * Uses the theme's CartApi so the cart drawer, item count and error
 * notifications stay in sync. Delegated from the document so cards added by
 * pagination or a filter refresh keep working.
 */
(function () {
	"use strict";

	var SELECTOR = ".js-verais-quick-add";
	var RESET_DELAY = 1400;

	function getCartApi() {
		return window.themeCore && window.themeCore.CartApi ? window.themeCore.CartApi : null;
	}

	function showError(error) {
		var notifier = window.themeCore && window.themeCore.CartNotificationError;
		var message = (error && error.description) || (error && error.message) || "";

		if (notifier) {
			notifier.addNotification(message);
			notifier.open();
			return;
		}

		console.error("Add to cart failed:", message || error);
	}

	function addToCart(button) {
		var variantId = button.getAttribute("data-variant-id");
		var CartApi = getCartApi();

		if (!variantId || !CartApi || button.dataset.state === "loading") {
			return;
		}

		button.dataset.state = "loading";

		CartApi.makeRequest(CartApi.actions.ADD_TO_CART, {
			id: variantId,
			quantity: 1
		})
			.then(function () {
				return CartApi.makeRequest(CartApi.actions.GET_CART);
			})
			.then(function () {
				button.dataset.state = "added";
				window.setTimeout(function () {
					if (button.dataset.state === "added") {
						button.dataset.state = "";
					}
				}, RESET_DELAY);
			})
			.catch(function (error) {
				button.dataset.state = "";
				showError(error);
			});
	}

	document.addEventListener("click", function (event) {
		var button = event.target.closest(SELECTOR);

		if (!button) {
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		if (!getCartApi()) {
			return;
		}

		addToCart(button);
	});
})();
